import { Card } from "@mui/material";
import {
  DataGridPro,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
  useGridApiRef,
} from "@mui/x-data-grid-pro";
import * as React from "react";
import { useEffect, useState } from "react";

import { Typography } from "@mui/material";
import { serverSideMatches } from "../api/matches";
import { IgniteInsightsCols } from "../columns/reefscape/igniteInsightsColumns";

async function ServerSideGrid(body) {
  console.log(body);
  try {
    const data = await serverSideMatches(body);
    if (!data?.body) throw new Error("Invalid API response");
    return data;
  } catch (error) {
    console.error("Error fetching users:", error);
    return { body: JSON.stringify({ data: [] }) };
  }
}

export default function UserMatchesGrid({ user }) {
  const [matchData, setMatchData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const apiRef = useGridApiRef();
  const [serverSideBody, setServerSideBody] = useState({
    itemCount: 10,
    offset: 0,
    teamNumber: user?.team_number ?? 0,
    sortModel: [],
    filterModel: {
      items: [
        {
          field: "username",
          operator: "equals",
          id: 12222,
          value: `${user?.first_name} ${user?.last_name}`,
          fromInput: ":rkf:",
        },
      ],
      logicOperator: "and",
      quickFilterValues: [],
      quickFilterLogicOperator: "and",
    },
  });

  useEffect(() => {
    const fetchData = async () => {
      let temp = { ...serverSideBody };
      if (temp?.filterModel?.items?.length === 0) {
        temp.filterModel.items.push({
          field: "username",
          operator: "equals",
          id: 12222,
          value: `${user?.first_name} ${user?.last_name}`,
          fromInput: ":rkf:",
        });
      }

      const result = await ServerSideGrid(temp);
      try {
        const parsedData = JSON.parse(result?.body);
        setRowCount(parsedData.totalRows ?? 0);
        setMatchData(Array.isArray(parsedData?.data) ? parsedData.data : []);
      } catch (error) {
        console.error("Error parsing user data:", error);
        setMatchData([]);
      }
    };

    fetchData();
  }, [serverSideBody]);

  useEffect(() => {
    setColumns(IgniteInsightsCols() || []);
  }, []);

  const handleSortModelChange = (sortModel) => {
    setServerSideBody((prev) => ({ ...prev, sortModel: sortModel }));
  };

  const handlePageChange = (pageModel) => {
    const { page, pageSize } = pageModel;
    const offset = page * pageSize;
    const itemsPerPage = pageSize;
    setServerSideBody((prev) => ({
      ...prev,
      itemCount: itemsPerPage,
      offset: offset,
    }));
  };

  const onFilterChange = (filterModel) => {
    let temp = { ...filterModel };
    setServerSideBody((prev) => ({ ...prev, filterModel: temp }));
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarQuickFilter />
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
      </GridToolbarContainer>
    );
  }

  return (
    <>
      {matchData.length > 0 && (
        <DataGridPro
          rows={matchData}
          columns={columns}
          sx={{ display: "flex", minHeight: "125px" }}
          apiRef={apiRef}
          pagination
          pageSizeOptions={[5, 10, 25]}
          rowCount={rowCount}
          disableSelectionOnClick
          density="compact"
          disableVirtualization
          filterMode="server"
          paginationMode="server"
          onFilterModelChange={onFilterChange}
          slots={{
            toolbar: CustomToolbar,
          }}
          sortingMode="server"
          onPaginationModelChange={handlePageChange}
          onSortModelChange={handleSortModelChange}
          getRowId={(row) => row?.match_id ?? ""}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10,
              },
            },
            pinnedColumns: { right: ["actions"] },
          }}
        />
      )}
      {matchData.length === 0 && (
        <Card sx={{ p: 5 }}>
          <Typography sx={{ textAlign: "center" }}>
            <b>No User Matches</b>
          </Typography>
        </Card>
      )}
    </>
  );
}
